import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import MDB4Switch from './../../../../../components/forms/MDB4Switch'
import { toast } from 'react-toastify'
import UserProfileService from './../../../../../shared/services/UserProfile.service'
import UserService from './../../../../../shared/services/User.service'

/*
 * White-Label toggle (UAD-3667).
 *
 * Admins (BST) flip this on a leader. When on, the leader and everyone in their
 * downline see the agency's white-label branding instead of USABG. This is a
 * simple flag (users.is_white_label) — it does NOT change the user's role.
 */
const isWhiteLabel = () => `${UserProfileService.get('is_white_label')}` === '1'

const WhiteLabelManagement = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [checked, setChecked] = useState(isWhiteLabel())

  // Only USABG admins / agency owners may toggle white-label.
  const meetsRequirement =
    UserProfileService.isA('internal-staff', true) ||
    UserProfileService.isA('internal-admin', true) ||
    UserProfileService.isA('system-admin', true) ||
    UserProfileService.isA('agency-owner', true)

  const toggleWhiteLabel = async () => {
    if (isLoading) return
    const next = checked ? 0 : 1
    setIsLoading(true)
    try {
      await UserService.update(UserProfileService.getUserId(), {
        is_white_label: next,
      })
      UserProfileService.set('is_white_label', next)
      setChecked(!!next)
      toast.success(`${next ? 'Enabled' : 'Disabled'} white-label for this agent.`, {
        position: toast.POSITION.TOP_RIGHT,
      })
    } catch (ex) {
      toast.error('Failed to update white-label setting.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
    setIsLoading(false)
  }

  if (!meetsRequirement) return <></>

  return (
    <MDBContainer fluid style={{ backgroundColor: 'rgba(255,255,255,0.5)', paddingTop: '10px' }}>
      <MDBRow>
        <MDBCol size='6' sm='7' md='9' lg='6'>
          <label>
            Enable White-Label for this agent?&nbsp;
            {isLoading ? (
              <span>
                <i className='fa fa-spin fa-spinner'></i>
              </span>
            ) : (
              <></>
            )}
          </label>
          <div>
            <small className='text-muted'>
              Hides USABG branding for this leader and their downline, showing the agency logo instead.
            </small>
          </div>
        </MDBCol>
        <MDBCol size='6' sm='5' md='3' lg='6' style={{ textAlign: 'right' }}>
          <MDB4Switch
            labelLeft={'No'}
            labelRight={'Yes'}
            disabled={!!isLoading}
            checked={checked}
            onChange={toggleWhiteLabel}
          />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  )
}

export default observer(WhiteLabelManagement)
